import * as React from 'react';

export const Listing: React.FC = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path d="M5 3L16 3" stroke="#0468FF" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
        <path d="M5 8H15" stroke="#0468FF" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
        <path d="M5 13L16.2507 13" stroke="#0468FF" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
        <circle cx="1" cy="8" r="1" fill="#0468FF" />
        <circle cx="1" cy="13" r="1" fill="#0468FF" />
        <circle cx="1" cy="3" r="1" fill="#0468FF" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

Listing.displayName = 'Listing';
